import { create } from 'zustand';
import type { ChatSummary } from '@/types/domain';

interface ChatsState {
  chats: ChatSummary[];
  setChats: (chats: ChatSummary[]) => void;
  upsertChat: (chat: ChatSummary) => void;
  incrementUnread: (chatId: number) => void;
  resetUnread: (chatId: number) => void;
  totalUnread: () => number;
}

export const useChatsStore = create<ChatsState>((set, get) => ({
  chats: [],
  setChats: (chats) => set({ chats }),
  upsertChat: (chat) =>
    set((s) => {
      const idx = s.chats.findIndex((c) => c.id === chat.id);
      if (idx === -1) return { chats: [chat, ...s.chats] };
      const next = s.chats.slice();
      next[idx] = chat;
      return { chats: next };
    }),
  incrementUnread: (chatId) =>
    set((s) => ({
      chats: s.chats.map((c) =>
        c.id === chatId ? { ...c, unread_count: c.unread_count + 1 } : c,
      ),
    })),
  resetUnread: (chatId) =>
    set((s) => ({
      chats: s.chats.map((c) => (c.id === chatId ? { ...c, unread_count: 0 } : c)),
    })),
  totalUnread: () => get().chats.reduce((sum, c) => sum + c.unread_count, 0),
}));
